var _excluded = ["as", "extend", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
var El = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    extend = _ref.extend,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useFela = useFela(),
    css = _useFela.css;
  var felaClassName = extend ? css(extend) : undefined;
  var componentClassName;
  if (className && felaClassName) {
    componentClassName = className + ' ' + felaClassName;
  } else if (className) {
    componentClassName = className;
  } else if (felaClassName) {
    componentClassName = felaClassName;
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    className: componentClassName
  }, props));
});
export default El;
El.displayName = 'El';
El.propTypes = {
  /** The HTML node that is rendered */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.elementType, PropTypes.func]),
  /** Adds a custom CSS class */
  className: PropTypes.string,
  /** Extends the Fela style object */
  extend: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array])
};